module.exports = __webpack_public_path__ + "static/media/cardFour.759be6ac.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Images/rowOne/cardFour.jpg
// module id = 79
// module chunks = 0